import react, { useState, useEffect, use } from "react";
import GuideLinkIcon from "./SocialLinkIcon";
import { getGuideTypeLabel, getGuideTypeImageUrlByHyphenatedTitle } from "./utils";

const defaultProfilePics = {
    female: "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/boggler-guide-female.png",
    male: "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/boggler-guide-male.png"
};

const PublicGuideProfileCard = (props) => {

    const [profileData, setProfileData] = useState(props.guideData || {});
    const [myRoles, setMyRoles] = useState(props.guideData?.roles || []);
    const [telPrefix, setTelPrefix] = useState("");
    const [guideTypeImages, setGuideTypeImages] = useState([]);

    const unSnakeCase = (text) => {
        if(!text) return "";
        return text.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
    }

    const getArticleForRole = (roleTitle) => {
        const vowels = ['a', 'e', 'i', 'o', 'u'];
        const firstLetter = roleTitle.charAt(0).toLowerCase();
        return vowels.includes(firstLetter) ? "an" : "a";
    }

    const getMyRolesAsString = () => {
        if(!myRoles || myRoles?.length === 0) return "a Friend";
        if(myRoles.length === 1) return " " + getArticleForRole(myRoles[0].title) + " " + myRoles[0].title+ ", and Friend";
        if(myRoles.length === 2) return " " + getArticleForRole(myRoles[0].title) + " " + myRoles[0].title + ", " + getArticleForRole(myRoles[1].title) + " " + myRoles[1].title+ ", and Friend";
        let rolesString = "";
        if(myRoles.length > 2) {
            for(let i = 0; i < myRoles.length; i++) {
                if(i < myRoles.length -1) {
                    rolesString += myRoles[i].title + ", ";
                } else {
                    rolesString += myRoles[i].title;
                }
            }
            return getArticleForRole(myRoles[0].title)+" " + rolesString+ ", and Friend";
        }
    }

    useEffect(() => {
        setProfileData(props.guideData || {});
        let theSelectedGuideTypeLabels = [];
        let guideTypeImagesArray = [];
        (async () => {
            if(props.guideData?.types && props.guideData.types.length > 0) {
                for(const type of props.guideData.types) {
                    let imageUrl = `https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/default-boggler-guide-profile-picture.png`;
                    try {
                        imageUrl = await getGuideTypeImageUrlByHyphenatedTitle(type);
                    } catch (error) {
                        console.error("Error fetching image URL for type:", type, error);
                    }
                    guideTypeImagesArray.push({ type: type, image: imageUrl });
                    let theGuideType = getGuideTypeLabel(type);
                    theSelectedGuideTypeLabels.push(theGuideType);
                }
                setGuideTypeImages(guideTypeImagesArray);
            }
        })()
        setMyRoles(props.guideData?.roles || []);
    }, [props.guideData]);


    return (
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%'}}>
            <div>
                <div className="profile-link-container">
                    Share my Profile <br className="mobile-break" />
                    <a 
                        style={{color: '#24afc2', textDecoration: 'underline'}} 
                        href={"https://theboggler.com/@"+profileData?.username} 
                        target="_blank" 
                        rel="noopener noreferrer" className="profile-link">https://theboggler.com/@{profileData?.username}</a>
                </div>
            </div>
            <div className="guide-profile-container">
                <div className="polaroid" key={profileData?._id}>
                    <div className="profile-country-badge">{profileData?.country?.name+" "+profileData?.country?.flag}</div>
                    <div className="profile-photo-wrapper">
                        <div className="guide-age-badge">
                            <span className="my-age">My age:</span> 
                            <span className="the-age-group">{" " + (profileData?.age || "Unknown")}</span>
                        </div>
                        <div className="guide-appointments-badge">
                        <span id="guideCredential" className={profileData?.credentials?.length > 1 ? "scrollText" : ""}>
                            {profileData?.work && (<span>Works in {profileData.work} industry</span>)}
                            </span>
                        </div>
                        <img className="guide-profile-image profile-photo" src={profileData?.profilePictureUrl || (profileData.presumedGender === "male" ? defaultProfilePics[0] : defaultProfilePics[1])} alt={profileData?.name} />
                    </div>
                    <div className="caption">
                        <h2 className="guide-profile-name">{profileData?.name || "Network Error"}</h2>
                    </div>
                </div>
                <div className="guide-profile-details">
                    {profileData?.realRoles && profileData?.realRoles.length > 0 && (
                        <div className="guide-real-roles">In the real world, I am {getMyRolesAsString()}</div>
                    )}
                    <div style={{display: 'flex', flexDirection: "row", flexWrap: "wrap", justifyContent: 'center', gap: '10px', margin: '20px auto'}}>
                    {guideTypeImages && guideTypeImages.length > 0 && 
                        guideTypeImages.map((type) => 
                            (
                                <div key={"guide-archetype-container-for-profile-"+type.type} style={{display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '0 5px'}}>
                                    <img
                                        key={"guide-archetype-image-for-profile-"+type.type}
                                        style={{width: '100px', height: '100px', borderRadius: '50%' }}
                                        src={type.image}
                                        alt={type.type}
                                        className="guide-archetype-image-for-profile"
                                    />
                                    <span key={"guide-archetype-label-for-profile-"+type.type} className="guide-archetype-label-for-profile">{getGuideTypeLabel(type.type)}</span>
                                </div>
                            ))
                    }
                </div>
                <div className="lucky-font" style={{ width: "100%", whiteSpace: "pre-wrap", maxHeight: "200px", overflowY: "scroll", textAlign: "center", alignContent: "center", fontSize: "1.2rem", margin: "15px auto" }}>{profileData?.motivation}</div>
                {profileData?.social_links?.length > 0 && (
                    <div className="profile-links-section-profile">
                        {profileData.social_links.map(({ platform, url }, i) => (
                            <div style={{display: 'flex', flexDirection: "column", alignItems: 'center', margin: '0 auto', padding: "5px"}} key={"link-item-"+platform+i}>
                                <GuideLinkIcon size={75} key={"social-icon"+platform+i} platform={platform} onClick={() => window.open(url, "_blank")} />
                            </div>
                        ))}
                    </div>
                )}
                <div>
                    {profileData?.willUseWhatsapp && (
                        <div>
                            <p>I use WhatsApp to connect with you. My WhatsApp number will be shared with you immediately after your purchase.</p>
                            <>
                            {profileData?.willUseWhatsapp && (
                                <div style={{ 
                                    padding: '20px', 
                                    borderRadius: '8px',
                                    marginBottom: '10px'
                                }}>
                                    <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '10px' }}>
                                        <a
                                            href={`https://wa.me/${(telPrefix+profileData?.phone_number).replace(/[^\d]/g, '')}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                background: '#25D366',
                                                color: 'white',
                                                padding: '12px 24px',
                                                borderRadius: '8px',
                                                textDecoration: 'none',
                                                fontWeight: 'bold',
                                                fontSize: '1em',
                                                display: 'inline-block'
                                            }}
                                        >
                                            💬 Open WhatsApp
                                        </a>
                                        <a
                                            href="https://www.whatsapp.com/download/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                background: 'transparent',
                                                color: '#24afc2',
                                                border: '2px solid #24afc2',
                                                padding: '12px 20px',
                                                borderRadius: '8px',
                                                textDecoration: 'none',
                                                fontWeight: 'bold',
                                                fontSize: '1em',
                                                display: 'inline-block'
                                            }}
                                        >
                                            ⬇️ Download WhatsApp
                                        </a>
                                    </div>
                                </div>
                                )}
                            </>
                        </div>
                    )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PublicGuideProfileCard;